var exports = {
  "f5": "xaf9ae18d--7961b8--building-icon",
  "vu": "xaf9ae18d--7961b8--active",
  "lq": "xaf9ae18d--7961b8--viewed",
};

module.exports = exports;
